import React, { useContext, useEffect, useState } from 'react';
import SummaryApi from '../common';
import Context from '../context';
import displayINRCurrency from '../helpers/displayCurrency';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AiOutlineLoading3Quarters } from 'react-icons/ai'; // Import the new spinner icon
import { useSelector } from 'react-redux';
import ROLE from '../common/role';
import defaultImage from '../assest/DAWACO_Icon.png'; 
import MinimumBar from '../components/MinimumBar';

const PaymentPage = () => {
    const [data, setData] = useState([]);
    const [userDetails, setUserDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false); // New state for button loading
    const context = useContext(Context);
    const navigate = useNavigate();
    const user = useSelector(state => state?.user?.user);
    const [length,setLength] = useState('0')
    var d = [];
    const [barMinimum, setBarMinimum] = useState('');
    const [purchasingManager, setPurchasingManager] = useState("");
    const [isManagerChanged, setIsManagerChanged] = useState(false);
    const [clientNotes, setClientNotes] = useState("");

    useEffect(() => {
        setLoading(true);
        const loadingTimeout = setTimeout(() => {
          
          setLoading(false);
          navigate("/");
        }, 10000); 
    
        if (user) {
          if (user?.role !== ROLE.GENERAL) {
            
            navigate("/");
            setLoading(false);
          } 
          else {

            setLoading(false);
            clearTimeout(loadingTimeout)
            handleLoading()
          }
        } 
    
        // Clear the timeout when the component unmounts or the effect is rerun
        return () => clearTimeout(loadingTimeout);
      }, [user, navigate]);


      const fetchBarMinimum= async () => {
        try {
            const response = await fetch(SummaryApi.getBarMinimum.url, {
                method: SummaryApi.getBarMinimum.method,
                credentials: 'include',
                headers: {
                    "Content-Type": 'application/json'
                }
            });
            const responseData = await response.json();
            setBarMinimum(responseData?.data);
        } catch (error) {
        }
    };

    const fetchData = async () => {
        try {
            const response = await fetch(SummaryApi.addToCartProductView.url, {
                method: SummaryApi.addToCartProductView.method,
                credentials: 'include',
                headers: {
                    'content-type': 'application/json',
                },
            });
            const responseData = await response.json();
            if (responseData.success) {
                setData(responseData.data);
                d = responseData.data;
                setLength(d.length)
            } else {
                toast.error('حدث خطأ');
            }
        } catch (error) {
            toast.error('حدث خطأ');
        }
    };

    const fetchUserDetails = async () => {
        try {
            const response = await fetch(SummaryApi.current_user.url, {
                method: SummaryApi.current_user.method,
                credentials: 'include',
                headers: {
                    'content-type': 'application/json',
                },
            });
            const responseData = await response.json();
            if (responseData.success) {
                setUserDetails(responseData?.data);
                setPurchasingManager(responseData?.data?.purchasingManager)
            } else {
                toast.error('حدث خطأ');
            }
        } catch (error) {
            toast.error('حدث خطأ');
        }
    };

    const handleLoading = async () => {
        await fetchData();
        await fetchUserDetails();
        await fetchBarMinimum();
    };



    const totalPrice = data.reduce((preve, curr) => {
        const price = curr?.productDetails?.sellingPrice > 0 ? curr?.productDetails?.sellingPrice : curr?.productDetails?.price;
        return preve + (curr?.quantity * price);
    }, 0);

    const handlePayment = async () => {
        let note;
        if(user?.pharmacistOrPharmacy==='pharmacist'){
            note=" يجب تحصيل المبلغ نقدا عند الاستلام من الصيدلى";
        }
        else{
            note="";
        }
        try {
            const response = await fetch(SummaryApi.payment.url, {
                method: SummaryApi.payment.method,
                credentials: 'include',
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify({
                    cartItems: d,
                    paymentMethod: 'cash',
                    type : d[0].type,
                    note : note,
                    purchasingManager: purchasingManager,
                    clientNotes: clientNotes,
                })
            });

            const responseData = await response.json();

            if (response.ok && responseData.success) {
                // Payment successful
            } else {
                toast.error("فشل الدفع. يرجى المحاولة مرة أخرى");
            }
        } catch (error) {
            toast.error("حدث خطأ أثناء عملية الدفع. يرجى المحاولة مرة أخرى.");
        }
    };

    const handleConfirmPayment = async () => {
        try {
            await fetchData();

            let isAvailable = true;
            let i = 0;

            while (isAvailable && i < d.length) {
                const product = d[i];
                if (product?.quantity > product?.productDetails?.quantity) {
                    isAvailable = false;
                }
                i++;
            }

            const targetProduct = d[i - 1];

            if (isAvailable) {
                try {
                    
                    const orderDetails = {
                        items: d.map((product) => {
                            const availableQuantity = product?.productDetails?.quantity - product?.quantity;
                            const bonusBasedOnRatio = (product?.productDetails?.toBonus > 0 && product?.productDetails?.bonusQuantity > 0) 
                                ? Math.floor(product?.quantity / product?.productDetails?.toBonus) * product?.productDetails?.bonusQuantity : 0;


                            const bonus = Math.min(
                                bonusBasedOnRatio,
                                availableQuantity > 0 ? availableQuantity : 0
                            );

                        return {
                            productName: product?.productDetails?.productName,
                            quantity: product?.quantity,
                            totalPrice: product?.quantity * (
                                product?.productDetails?.sellingPrice > 0 
                                    ? product?.productDetails?.sellingPrice 
                                    : product?.productDetails?.price
                            ),
                            bonus: bonus
                        };

                        }),
                        totalPrice: totalPrice,
                        shippingAddress: userDetails?.shippingAddress,
                        date: new Date().toLocaleDateString(),
                        purchasingManager: purchasingManager
                    };

                    const response = await fetch(SummaryApi.userOrderMail.url, {
                        method: SummaryApi.userOrderMail.method,
                        credentials: 'include',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            userId: userDetails?._id,
                            orderDetails: orderDetails,
                        }),
                    });

                    const responseData = await response.json();

                    if(userDetails.pharmacistOrPharmacy==="pharmacy"){

                       await fetch(SummaryApi.updateUserDebt.url, {
                        method: SummaryApi.updateUserDebt.method,
                        credentials: 'include',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            userId: userDetails?._id,
                            addedDebt: totalPrice,
                            type : d[0].type,
                        }),
                    });

                }
                        await fetch(SummaryApi.updateProductsQuantity.url, {
                        method: SummaryApi.updateProductsQuantity.method,
                        credentials: 'include',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            userId: userDetails?._id,
                            type : d[0].type,
                            isSalesManBonus:false,
                            bonusQuantities:[]
                        }),
                    });

                    if (responseData.success) {
                        await handlePayment();
                        const clearCartResponse = await fetch(SummaryApi.clearCartProduct.url, {
                            method: 'POST',
                            credentials: 'include',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        });

                        const clearCartResponseData = await clearCartResponse.json();

                        if (clearCartResponseData.success) {
                            toast.success('تم تقديم الطلب بنجاح');
                            context.fetchUserAddToCart(); // Update cart product count in context
                            navigate('/'); // Navigate to home page
                        } else {
                            toast.error('فشل في إفراغ العربة');
                        }
                    } else {
                        toast.error(responseData.message || 'فشل في تقديم الطلب');
                    }
                } catch (error) {
                    toast.error(' حدث خطأ. يرجى المحاولة مرة أخرى');
                }
            } else {
                toast.error(`يوجد فقط ${targetProduct.productDetails.quantity} منتجات متوفرة في المخزن من "${targetProduct.productDetails.productName}" و أنت تحاول طلب ${targetProduct.quantity} منتجات.`);
            }
        } catch (error) {
            toast.error('حدث خطأ. يرجى المحاولة مرة أخرى');
        } finally {
            setButtonLoading(false); 
        }
    };

    const handleConfirmPaymentAndPayment = async () => {
        setButtonLoading(true); 
        if(isManagerChanged){
            handleManagerChanged();
          }
        await handleConfirmPayment();
    };

    const handleManagerChanged =  () => {
        try {
          console.log("hi" , purchasingManager ,user?._id ,user?.name)
           fetch(SummaryApi.editManager.url, {
            method: SummaryApi.editManager.method,
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              userId: user?._id,
              purchasingManager:purchasingManager
            }),
          });
        } catch (error) {
        } 
      };

    if (loading) {
        return (
          <div className="flex justify-center items-center h-screen">
            <AiOutlineLoading3Quarters className="animate-spin text-6xl text-blue-500" />
          </div>
        );
      }

    return (
        <div className="container mx-auto">
               {barMinimum?.at(0)?.seq > totalPrice && (
                <MinimumBar />
            )}

            <div className="flex flex-col lg:flex-row gap-10 lg:justify-between p-4">
                {/* Left Section: Product Summary */}
                <div className="w-full max-w-xl">
                    <h2 className="text-2xl font-bold mb-4">ملخص الطلب</h2>
                    {loading ? (
                        new Array(4).fill(null).map((_, index) => (
                            <div key={index} className="w-full bg-slate-200 h-40 my-2 border border-slate-300 animate-pulse rounded"></div>
                        ))
                    ) : (
                        data.map((product) => (
                            <div key={product?._id} className="w-full bg-white h-40 my-2 border border-slate-300 rounded grid grid-cols-[128px,1fr]">
                                <div className="w-32 h-40 bg-slate-200">
                                    <img
                                        src={product?.productDetails?.productImage[0] || defaultImage}
                                        className="w-full h-full object-scale-down mix-blend-multiply"
                                        alt="product"
                                    />
                                </div>
                                <div className="px-4 py-2 text-right">
                                    <h3 className="text-lg">{product?.productDetails?.productName}</h3>
                                    <p className="text-sm"> {product?.quantity} : الكمية</p>
                                    {product?.productDetails?.toBonus>0 && product?.productDetails?.bonusQuantity>0 && product?.quantity > product?.productDetails?.toBonus &&(
                                    <p className="text-sm"> {Math.max(Math.min((Math.floor(product?.quantity / product?.productDetails?.toBonus)) * product?.productDetails?.bonusQuantity,
                                        product?.productDetails?.quantity-product?.quantity),0)} : البونص</p>
                                    )}
                                    <p className="text-sm">
                                         {displayINRCurrency(product?.productDetails?.sellingPrice > 0 ? product?.productDetails?.sellingPrice : product?.productDetails?.price)} : سعر المنتج 
                                    </p>
                                    <p className="font-bold">
                                        {displayINRCurrency(product?.quantity * (product?.productDetails?.sellingPrice > 0 ? product?.productDetails?.sellingPrice : product?.productDetails?.price))} : الإجمالى 
                                    </p>

                                </div>
                            </div>
                        ))
                    )}
                    {!loading && (
                        <div className="mt-4 text-right">
                            <h3 className="text-xl font-bold"> {displayINRCurrency(totalPrice)} : السعر الإجمالى</h3>
                        </div>
                    )}
                </div>

                {/* Right Section: Payment Option */}
                <div className="mt-5 lg:mt-0 w-full max-w-sm">
                    {loading ? (
                        <div className="h-36 bg-slate-200 border border-slate-300 animate-pulse"></div>
                    ) : (
                        <div className="bg-white p-4 border shadow-md text-right">
                            <h2 className="text-2xl font-bold mb-4">خيارات الدفع</h2>
                            <div className="text-right ">

                                 <label htmlFor="cash" className="ml-2 ">الدفع نقدا  </label>
                                <input type="radio" id="cash" name="payment" value="cash" checked readOnly />
                                
                            </div>

                            {user?.pharmacistOrPharmacy === 'pharmacy' && (
              <div>
                <div className="text-right">
                  <h3 className="font-semibold">: مدير المشتريات <span className='text-red-500 font-bold mr-1'>*</span></h3>
                </div>
                <input
                  type="text"
                  name="purchasingManager"
                  value={purchasingManager}
                  onChange={(e) => {
                    setPurchasingManager(e.target.value)
                    setIsManagerChanged(true);
                  }}
                  className="border rounded p-1 w-full bg-gray-50 text-sm text-right"
                />
              
              <div className="text-right">
                <h3 className="font-semibold">: ملحوظات</h3>
                </div>
                <textarea
                name="clientNotes"
                value={clientNotes}
                onChange={(e) => setClientNotes(e.target.value)}
                className="border rounded p-2 w-full bg-gray-50 text-sm text-right h-24"
                />
            </div>


              
    )}
                            <button
    className={`mt-4 py-2 px-4 bg-green-500 hover:bg-green-600 text-white rounded ${barMinimum?.at(0)?.seq > totalPrice || buttonLoading || length === 0 || purchasingManager === ""? 'opacity-50 cursor-not-allowed' : ''}`}
    onClick={handleConfirmPaymentAndPayment}
    disabled={barMinimum?.at(0)?.seq > totalPrice || buttonLoading || length === 0 || purchasingManager === ""}
>
    {buttonLoading ? <AiOutlineLoading3Quarters className="animate-spin" /> : 'تنفيذ الطلب '}
</button>

                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PaymentPage;
